import styled from "styled-components";
import { ColorVariables } from "manifest-components/src/Colors";
import DisclaimerLandingPage from "manifest-components/src/LegalDisclaimer/disclaimers/DisclaimerLandingPage";
import WelcomeContainer from "../WelcomeContainer";

const StyledFooter = styled.div`
  height: 438px;
  background: ${ColorVariables.orange5};
`;

export default function FooterSection() {
  return (
    <StyledFooter className="footer">
      <WelcomeContainer
        style={{
          paddingTop: "60px",
          flexDirection: "column",
        }}
        $mobilePaddingTop={30}
      >
        <DisclaimerLandingPage />
      </WelcomeContainer>
    </StyledFooter>
  );
}
